import {
  differenceInDays,
  differenceInMonths,
  differenceInWeeks,
  differenceInYears
} from 'date-fns';
import type { RepeatType, ScheduleSolversDisplayConfigType } from '../types';

type CalculateDifference = typeof differenceInDays;
const calculateDifferenceFunctions: Record<
  Exclude<RepeatType, 'noRepeat'>,
  CalculateDifference
> = {
  daily: differenceInDays,
  weekday: differenceInWeeks,
  weeklyOn: differenceInWeeks,
  sameDayInMonth: differenceInMonths,
  nthDayInMonth: differenceInMonths,
  lastDayInMonth: differenceInMonths,
  annuallyOn: differenceInYears
};

export const getCycleIndex = ({
  startDate,
  userDate,
  repeatType = 'noRepeat',
  freq = 1
}: ScheduleSolversDisplayConfigType) => {
  if (repeatType === 'noRepeat') {
    return 0;
  }

  const calculateDifference = calculateDifferenceFunctions[repeatType];
  const difference = calculateDifference(userDate, startDate);

  return Math.max(0, Math.floor(difference / freq));
};
